const FunzionarioLeaderStructure = {

    getStructure: function () {
        return {
            section : 
            {
                name: "Compila i seguenti campi",
                id: "funzionarioLeaderForm",
                description: "Sezione dedicata al funzionario e alle prime analisi",
                multipleValue: false,
                rows : [
                {
                    id : "row1",
                    fields : [
                        {
                            name: "demacoFileNumber",
                            type: "text",
                            numColMd: 9,
                            label: "Fascicolo Segnalazione Su Demaco",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "associaFascicolo",
                            type: "buttonFascicolo",
                            numColMd: 3,
                            label: "Assegna Fascicolo - Demaco",
                            required: false,
                            tooltipText: "",      
                        },
                    ]
                },
                {
                    id : "row2",
                    fields : [
                        {
                            name: "notaDemaco",
                            type: "text",
                            numColMd: 9,
                            label: "Nota MAB /Lettera URI Demaco",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "notaDemacoButton",
                            type: "buttonNotaDem",
                            numColMd: 3,
                            label: "Protocollo MAB/URI - Demaco",
                            required: false,
                            tooltipText: "",      
                        }
                    ]
                },
                {
                    id : "row3",
                    fields : [
                        {
                            name: "notaFilenet",
                            type: "textNota",
                            numColMd: 9,
                            label: "Nota MAB /Lettera URI Filenet",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "notaDemacoButton",
                            type: "buttonNotaFil",
                            numColMd: 3,
                            label: "Vedi Nota Mab /Lettera Uri - Filenet",
                            required: false,
                            tooltipText: "",      
                        }
                    ]
                },
                {
                    id : "row4",
                    fields : [
                        {
                            name: "evoSegnalazione",
                            type: "textAreaEvo",
                            numColMd: 9,
                            label: "Evoluzione Segnalazione",
                            required: false,
                            tooltipText: "",
                        }
                    ]
                },
                // {
                //     id : "row5",
                //     fields : [
                //         {
                //             name: "forwardingDate",
                //             type: "date",
                //             numColMd: 9,
                //             label: "Evoluzione Segnalazione",
                //             required: false,
                //             tooltipText: "",
                //         }
                //     ]
                // }
            ]}  
        }
    }
}

export default FunzionarioLeaderStructure;